import type {
  AdminPaginatedEnvelope,
  AfriexFeature,
  AfriexFeatureField,
  AfriexFeatureLimitDraft,
  AfriexFeatureTags,
} from '@/types';
import type {AfriexQueryParams} from '@/types/AfriexQueryParams';

export type FeatureListProps<T> = {
  /**
   * Whatever the fetchers caught. Was `typeof Error | null`, which is the
   * `Error` *constructor* rather than an error instance.
   */
  error: unknown;
  isLoading: boolean;
  isSearch?: boolean;
  isPageReset?: boolean;
  pageInfo: {
    total: number;
    page: number;
    summary?: AdminPaginatedEnvelope<T[]>['summary'];
  };
  list: T[];
  fetchList: (params: AfriexQueryParams) => void;
  setPage: (page: number) => void;
  filterCount: number;
  currentFilters: AfriexQueryParams;
  filtersToApply: AfriexQueryParams;
  clearFilters: () => void;
  selectAppliedFilters: (
    name: string,
    value: string | Date | number | undefined,
  ) => void;
  handleApplyFilters: () => void;
  selectCurrentFilters: (
    name: string,
    value: string | Date | undefined,
  ) => void;
};

export enum FeatureActionType {
  UPDATE_FEATURE = 'UPDATE_FEATURE',
  ADD_TAG = 'ADD_TAG',
  UPDATE_TAG = 'UPDATE_TAG',
  REMOVE_TAG = 'REMOVE_TAG',
  UPDATE_LIMIT = 'UPDATE_LIMIT',
}

interface UpdateFeatureAction {
  type: FeatureActionType.UPDATE_FEATURE;
  payload: Partial<AfriexFeature>;
}

interface AddFeatureTagAction {
  type: FeatureActionType.ADD_TAG;
  payload: AfriexFeatureTags;
}
interface UpdateFeatureTagAction {
  type: FeatureActionType.UPDATE_TAG;
  payload: AfriexFeatureTags;
}

interface RemoveFeatureTagAction {
  type: FeatureActionType.REMOVE_TAG;
  payload: AfriexFeatureField;
}
interface UpdateFeatureLimitAction {
  type: FeatureActionType.UPDATE_LIMIT;
  payload: AfriexFeatureLimitDraft;
}

export type FeatureAction =
  | UpdateFeatureAction
  | AddFeatureTagAction
  | UpdateFeatureTagAction
  | RemoveFeatureTagAction
  | UpdateFeatureLimitAction;
